import React from "react";

import { useAutoAnimate } from "@formkit/auto-animate/react";

import Stack, { StackProps } from "@readai/pulse/components/Stack";

interface AutoAnimateContainerProps extends StackProps {
  show: boolean;
}

/**
 * Basic container useful for making something appear/disappear in response to a boolean `show` value.
 * Effectively the same as the MUI Collapse component, but less finicky.
 * */
const AutoAnimateContainer = ({
  children,
  show,
  ...props
}: AutoAnimateContainerProps) => {
  const [containerRef] = useAutoAnimate();

  return (
    <Stack {...props} ref={containerRef}>
      {show ? children : null}
    </Stack>
  );
};

export default AutoAnimateContainer;
